import classNames from "classnames";
import VLSlider from "views/uikit/VLSlider";
import { VLInputNumber } from "views/uikit/FormFields/VLInput/VLInput";

import styles from "./style.module.scss";

export interface VLSliderWithInputProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  onValueChange: (value: number) => void;
  disabled?: boolean;
  className?: string;
}

function precisionFromStep(step: number): number {
  if (!Number.isFinite(step) || Math.floor(step) === step) {
    return 0;
  }
  const str = step.toString();
  if (str.includes("e-")) {
    return Math.max(0, parseInt(str.split("e-")[1] ?? "0", 10));
  }
  const dot = str.indexOf(".");
  return dot === -1 ? 0 : Math.min(str.length - dot - 1, 10);
}

export default function VLSliderWithInput({
  label,
  value,
  min,
  max,
  step = 1,
  unit = "",
  onValueChange,
  disabled = false,
  className,
}: VLSliderWithInputProps) {
  const precision = precisionFromStep(step);

  const clamp = (n: number) => Math.min(max, Math.max(min, n));

  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.labelRow}>
        <label className={styles.label}>{label}</label>
        <div className={styles.valueRow}>
          <VLInputNumber
            className={styles.inputNumber}
            value={value}
            min={min}
            max={max}
            step={step}
            precision={precision}
            disabled={disabled}
            onChange={(v) => {
              if (v === null) {
                return;
              }
              onValueChange(clamp(Number(v)));
            }}
          />
          {unit && <span className={styles.unit}>{unit}</span>}
        </div>
      </div>

      <div
        className={classNames(styles.sliderContainer, {
          [styles.disabled]: disabled,
        })}
      >
        <span className={styles.rangeLabel}>
          {min}
          {unit}
        </span>

        <VLSlider
          className={styles.slider}
          style={{ width: "100%" }}
          min={min}
          max={max}
          step={step}
          value={value}
          disabled={disabled}
          onChange={(v) => {
            if (typeof v === "number") {
              onValueChange(clamp(v));
            }
          }}
        />

        <span className={styles.rangeLabel}>
          {max}
          {unit}
        </span>
      </div>
    </div>
  );
}
